<template>
  <aside class="participants-sidebar">
    <div class="card rounded participants-sidebar__card shadow-none">
      <div class="card-body p-3 p-lg-4">
        <section class="participants-sidebar__section">
          <h6 class="participants-sidebar__section-title text-gray-700">{{ insurerTitle }}</h6>
          <customer-bpm-card
            v-if="insurer"
            :client="insurer"
            variant="sidebar"
            :changeDisabled="true"
            :mode="mode"
            :module="module"
            class="mb-2"
          />
        </section>

        <section class="participants-sidebar__section">
          <h6 class="participants-sidebar__section-title text-gray-700">{{ insuredsTitle }}</h6>
          <customer-bpm-card
            v-for="(item, key) in insureds"
            :key="'participants-insured-' + key"
            :client="item"
            variant="sidebar"
            :changeDisabled="true"
            :mode="mode"
            :module="module"
            class="mb-2"
          />
        </section>

        <section class="participants-sidebar__section">
          <h6 class="participants-sidebar__section-title text-gray-700">{{ vehiclesTitle }}</h6>
          <vehicle-bpm-card
            v-for="(item, key) in vehicles"
            :key="'participants-vehicle-' + key"
            :vehicle="item"
            variant="sidebar"
            :changeDisabled="true"
            :mode="mode"
            class="mb-2"
          />
        </section>
      </div>
    </div>
  </aside>
</template>

<script>
import CustomerBpmCard from '@/components/Form/Bpm/Customer/CustomerBpmCard.vue'
import VehicleBpmCard from '@/components/Form/Bpm/Vehicle/VehicleBpmCard.vue'

export default {
  name: 'ParticipantsSidebar',
  components: {
    CustomerBpmCard,
    VehicleBpmCard
  },
  props: {
    insurer: {
      type: Object,
      default: null
    },
    insureds: {
      type: Array,
      default: () => []
    },
    vehicles: {
      type: Array,
      default: () => []
    },
    module: {
      type: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    },
    title: {
      type: String,
      default: 'Участники'
    },
    insurerTitle: {
      type: String,
      default: 'Страхователь'
    },
    insuredsTitle: {
      type: String,
      default: 'Водители'
    },
    vehiclesTitle: {
      type: String,
      default: 'Авто'
    }
  }
}
</script>

<style scoped>
.participants-sidebar {
  min-width: 0;
  max-width: 100%;
}

.participants-sidebar__card {
  min-width: 0;
}

@media (min-width: 992px) {
  .participants-sidebar {
    position: sticky;
    top: 0;
    align-self: flex-start;
  }
}

.participants-sidebar__section + .participants-sidebar__section {
  margin-top: 1.25rem;
}

.participants-sidebar__section-title {
  font-size: 0.85rem;
  margin-bottom: 0.65rem;
}
</style>
